import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import * as OT from '@opentok/client';

@Injectable()
export class OpenTokService {
  chatAction = new Subject();

  session: OT.Session;
  apiKey = "46059732";
  sessionId = "2_MX40NjA1OTczMn5-MTUxODc4OTc1NjMxN35RVHloMkxHdi9udDFwNHJiUEQ3cUp3Q3N-fg";
  token = "T1==cGFydG5lcl9pZD00NjA1OTczMiZzaWc9NDJlNGNmNzE5NDE2YjM5ZGZlNDAxMTlhMGQxNTk3NWE3NjQxNjQzYjpzZXNzaW9uX2lkPTJfTVg0ME5qQTFPVGN6TW41LU1UVXhPRGM0T1RjMU5qTXhOMzVSVkhsb01reEhkaTl1ZERGd05ISmlVRVEzY1VwM1EzTi1mZyZjcmVhdGVfdGltZT0xNTE4Nzg5Nzc4Jm5vbmNlPTAuNjcwMzY2Nzc2MjAxMzAxNSZyb2xlPXB1Ymxpc2hlciZleHBpcmVfdGltZT0xNTIxMzgxNzc2JmluaXRpYWxfbGF5b3V0X2NsYXNzX2xpc3Q9";
  sampleUrl = "https://opentok-web-samples-backend.herokuapp.com";

  constructor() { }

  getOT() {
    return OT;
  }

  initSession() {
    if (this.apiKey && this.token && this.sessionId) {
      this.session = this.getOT().initSession(this.apiKey, this.sessionId);
      return Promise.resolve(this.session);
    } else {
      return fetch(this.sampleUrl + '/session')
        .then((data) => data.json())
        .then((json) => {
          this.session = this.getOT().initSession(json.apiKey, json.sessionId);
          this.token = json.token;
          return this.session;
        });
    }
  }

  connect() {
    return new Promise((resolve, reject) => {
      this.session.connect(this.token, (err) => {
        if (err) {
          reject(err);
        } else {
          resolve(this.session);
        }
      })
    });
  }

  getAction(): Observable<any> {
    return this.chatAction.asObservable();
  }

  sendAction(action, data) {
    return this.chatAction.next({ action: action, data: data });
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/open-tok/services/open-tok.service.ts